import { render, staticRenderFns } from "./testredenvelope.vue?vue&type=template&id=7be4e08d&scoped=true"
import script from "./testredenvelope.vue?vue&type=script&lang=js"
export * from "./testredenvelope.vue?vue&type=script&lang=js"
import style0 from "./testredenvelope.vue?vue&type=style&index=0&id=7be4e08d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be4e08d",
  null
  
)

export default component.exports